module.exports = __webpack_public_path__ + "img/rollcall_5.97871fa0.png";